import container from '../container/container';

const router = (function () {

    let publicVars = {};

    let privateVars = {
        name: 'router',

        disabled: false,

        trackedUrls: new Map()
    };


    var privateMethods = {
        prepareObj: function () {
            privateMethods.startup();
            privateMethods.bind();
        },
        startup: function () {

        },
        bind: function () {
            container.msg(privateVars.name, 'module started');
        },

        route: function (url, metaTitle, options) {

            if (!privateVars.disabled) {
                container.msg(privateVars.name, 'route to: ' + url);

                if (window.history.replaceState) {
                    window.history.replaceState({}, "", url);
                }

                if (metaTitle) {
                    document.title = metaTitle;
                }

                if((!options || !options.disableTrack) && !privateVars.trackedUrls.has(url) && options.disableTrackForUrl !== url) {
                    privateVars.trackedUrls.set(url, true);
                    container.trackPageView({
                        'pageName': options.pageName,
                        'page_name': options.pageName,
                        'content_title': metaTitle.toLowerCase().replace(/"/g, "'"),
                        ...(options.trackAdd || {})});
                }


            } else {
                container.msg(privateVars.name, 'disabled router to: ' + url);
            }
        },

        disable: function () {
            privateVars.disabled = true;
        },
        enable: function () {
            privateVars.disabled = false;
        }

    };


    return {
        init: function () {
            privateMethods.prepareObj();
        },
        route: function (url, meta, options) {
            privateMethods.route(url, meta, options);
        },
        disable: function () {
            privateMethods.disable();
        },
        enable: function () {
            privateMethods.enable();
        }
    }
})();

export default router;

/*
 ---
 var router = routerFactory.create();
 ---
 router.route('route');
 ---
 */